import React from 'react';

const Events = () => /* @__PURE__ */ React.createElement(
  "svg",
  {
    width: "20",
    height: "20",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  },
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M13.3333 15C13.7754 15 14.1993 15.1756 14.5118 15.4882C14.8244 15.8007 15 16.2246 15 16.6667C15 16.2246 15.1756 15.8007 15.4882 15.4882C15.8007 15.1756 16.2246 15 16.6667 15C16.2246 15 15.8007 14.8244 15.4882 14.5119C15.1756 14.1993 15 13.7754 15 13.3333C15 13.7754 14.8244 14.1993 14.5118 14.5119C14.1993 14.8244 13.7754 15 13.3333 15ZM13.3333 5.00001C13.7754 5.00001 14.1993 5.1756 14.5118 5.48817C14.8244 5.80073 15 6.22465 15 6.66668C15 6.22465 15.1756 5.80073 15.4882 5.48817C15.8007 5.1756 16.2246 5.00001 16.6667 5.00001C16.2246 5.00001 15.8007 4.82442 15.4882 4.51185C15.1756 4.19929 15 3.77537 15 3.33334C15 3.77537 14.8244 4.19929 14.5118 4.51185C14.1993 4.82442 13.7754 5.00001 13.3333 5.00001ZM7.5 15C7.5 13.6739 8.02678 12.4022 8.96447 11.4645C9.90215 10.5268 11.1739 10 12.5 10C11.1739 10 9.90215 9.47323 8.96447 8.53554C8.02678 7.59786 7.5 6.32609 7.5 5.00001C7.5 6.32609 6.97322 7.59786 6.03553 8.53554C5.09785 9.47323 3.82608 10 2.5 10C3.82608 10 5.09785 10.5268 6.03553 11.4645C6.97322 12.4022 7.5 13.6739 7.5 15Z",
      stroke: "#FF961C",
      strokeWidth: "1.5",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  )
);

export { Events };
//# sourceMappingURL=Events.js.map
